import React from "react";

const NotFoundPage = () => (
    <h1>404: This page doesn't exist!</h1>
);

export default NotFoundPage;